import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-unit-qr-code',
  templateUrl: './unit-qr-code.component.html',
  styleUrls: ['./unit-qr-code.component.scss']
})
export class UnitQrCodeComponent {
  @Input() qrCodeText: string;
  @Input() qrCodeLabel: string;
  @Input() qrCodeLink: string;

  constructor() {
  }

}
